import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {CmsConfig, ConfigModule, provideFeatureToggles} from '@spartacus/core';
import { GenericLinkModule, MediaModule } from '@spartacus/storefront';
import { CustomBannerComponent } from './custom-banner.component';

@NgModule({
  declarations: [CustomBannerComponent],
  imports: [
    CommonModule,
    RouterModule, GenericLinkModule, MediaModule,
    ConfigModule.withConfig({
      cmsComponents: {
        SimpleResponsiveBannerComponent: {
          component: CustomBannerComponent,
        },
        BannerComponent: {
          component: CustomBannerComponent,
        },
      },
    } as CmsConfig)
  ]
})
export class CustomBannerModule { }
